module.exports = __webpack_public_path__ + "static/media/thankyouBannerMobile.5959f4b1.jpg";